require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-introducing-sitelify.json") })
        }
      }, "path---posts-introducing-sitelify");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-introducing-sitelify!./.cache/json/posts-introducing-sitelify.json
// module id = 366
// module chunks = 231608221292675